export const state = {
  StudentRoster: [],
  AdultRoster: [],
  RosterClasses: [],
  AdultRosterClasses: [],
};
